import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { DetailPanel, DetailPanels } from "@/components/organisms";
import { InvoiceDetails } from "@/shared/domain";

import { invoiceContractSchema, invoiceDescriptionSchema } from "./panelSchema";

type InvoiceDetailsPanelProps = {
    invoice: InvoiceDetails;
};

enum AccordionIndex {
    PaymentDetails = "paymentDetails",
    ContractDetails = "contractDetails",
}

const InvoiceDetailsPanel: FC<InvoiceDetailsPanelProps> = ({ invoice }) => {
    const { t, i18n } = useTranslation();

    if (!invoice) return <> </>;

    return (
        <DetailPanels defaultDetailPanelOpen={AccordionIndex.PaymentDetails}>
            <DetailPanel
                dataTestId="invoice_details_payment_details"
                id={AccordionIndex.PaymentDetails}
                title={t("Invoice.Details.PaymentDetails")}
                infoList={invoiceDescriptionSchema(invoice, i18n.language)}
            />
            <DetailPanel
                dataTestId="invoice_details_contract_details"
                id={AccordionIndex.ContractDetails}
                title={t("Invoice.Details.ContractDetails")}
                infoList={invoiceContractSchema(invoice)}
            />
        </DetailPanels>
    );
};

export default InvoiceDetailsPanel;
